import { Box, Text } from "@modernatx-internal/component-library";

import { ContentComponentProps, ResultCardContent } from "@/content-V2/types";

export const ResultCard: React.FC<ContentComponentProps<ResultCardContent>> = ({
  children,
  label,
  variant = "warning"
}) => {
  return (
    <Box
      sx={{
        backgroundColor: `feedback-surface-${variant}`,
        borderLeft: "6px solid",
        borderLeftColor: `feedback-onSurface-incidental-${variant}`,
        display: "flex",
        flexDirection: "column",
        padding: 6,
        gap: 2,
        width: "100%"
      }}
    >
      {label && (
        <Text
          weight="bold"
          size="font-size-2"
          lineHeight="leading-1"
          letterSpacing="kerning-4"
          sx={{ color: "text-secondary" }}
        >
          {label}
        </Text>
      )}
      <Text sx={{ color: "text-secondary" }}>{children}</Text>
    </Box>
  );
};
